module.exports = __webpack_public_path__ + "static/media/faixa.2839a920.png";